import { useCallback } from 'react';
import { useAppDispatch } from '.';
import { setTxIsOngoing } from '../redux/slices/bridgeSlice';
import notificationFavicon from '../assets/img/notification_icon_80x80.png';

const useNotification = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (notificationMessage: string) => {
      const notification = new Notification(`K STADIUM BRIDGE`, {
        body: notificationMessage,
        icon: notificationFavicon,
      });
      dispatch(setTxIsOngoing(true));
    },
    [dispatch],
  );
};

export default useNotification;
